var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgH2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 45,
    fill: "url(#paint0_linear_282_6917)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 38C59.7957 38 60.5587 37.6839 61.1213 37.1213C61.6839 36.5587 62 35.7956 62 35V29C62 28.2044 61.6839 27.4413 61.1213 26.8787C60.5587 26.3161 59.7957 26 59 26H53C52.2044 26 51.4413 26.3161 50.8787 26.8787C50.3161 27.4413 50 28.2044 50 29V30.5H38V29C38 28.2044 37.6839 27.4413 37.1213 26.8787C36.5587 26.3161 35.7956 26 35 26H29C28.2044 26 27.4413 26.3161 26.8787 26.8787C26.3161 27.4413 26 28.2044 26 29V35C26 35.7956 26.3161 36.5587 26.8787 37.1213C27.4413 37.6839 28.2044 38 29 38H30.5V50H29C28.2044 50 27.4413 50.3161 26.8787 50.8787C26.3161 51.4413 26 52.2044 26 53V59C26 59.7957 26.3161 60.5587 26.8787 61.1213C27.4413 61.6839 28.2044 62 29 62H35C35.7956 62 36.5587 61.6839 37.1213 61.1213C37.6839 60.5587 38 59.7957 38 59V57.5H50V59C50 59.7957 50.3161 60.5587 50.8787 61.1213C51.4413 61.6839 52.2044 62 53 62H59C59.7957 62 60.5587 61.6839 61.1213 61.1213C61.6839 60.5587 62 59.7957 62 59V53C62 52.2044 61.6839 51.4413 61.1213 50.8787C60.5587 50.3161 59.7957 50 59 50H57.5V38H59ZM53 29H59V35H53V29ZM29 29H35V31.9813C34.9975 31.9936 34.9975 32.0064 35 32.0187V35H29V29ZM35 59H29V53H35V55.9812C34.9975 55.9936 34.9975 56.0064 35 56.0188V59ZM59 59H53V53H59V59ZM54.5 50H53C52.2044 50 51.4413 50.3161 50.8787 50.8787C50.3161 51.4413 50 52.2044 50 53V54.5H38V53C38 52.2044 37.6839 51.4413 37.1213 50.8787C36.5587 50.3161 35.7956 50 35 50H33.5V38H35C35.7956 38 36.5587 37.6839 37.1213 37.1213C37.6839 36.5587 38 35.7956 38 35V33.5H50V35C50 35.7956 50.3161 36.5587 50.8787 37.1213C51.4413 37.6839 52.2044 38 53 38H54.5V50Z",
    fill: "#FFFADD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_282_6917",
    x1: 0,
    y1: 45,
    x2: 90,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#776D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463C01"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgH2);
export default __webpack_public_path__ + "static/media/h-2.98eb5570831052929eb61fd0833a74f9.svg";
export { ForwardRef as ReactComponent };